import { data } from '../../svg/ProductRecommendation/data';
import { makeIcon } from '../makeIcon';

export const ProductRecommendation = makeIcon(data, 'product_recommendation', 'ProductRecommendation');

export default ProductRecommendation;
